module.exports.createRole = require('./create-role.json');
module.exports.rolesParams = require('./roles-params.json');
module.exports.updateRole = require('./update-role.json');
module.exports.viewRolesQuery = require('./view-roles-query.json');
